import React, { useState, useEffect, useRef } from "react";
import { View, TouchableOpacity, Animated, StyleSheet, I18nManager } from "react-native";
import {RFValue} from "react-native-responsive-fontsize";

const SwitchToggle = ({ mainColor = '#0D1134', secondColor = '#FFCC3E', onToggle , defaultValue = false  }) => {
    const [isOn, setIsOn] = useState(defaultValue);
    const animation = useRef(new Animated.Value(0)).current;



    useEffect(() => {
        Animated.timing(animation, {
            toValue: isOn ? 1 : 0,
            duration: 250,
            useNativeDriver: false,
        }).start();
    }, [isOn]);

    // اگر RTL باشه جهت برعکس میشه
    const translateX = animation.interpolate({
        inputRange: [0, 1],
        outputRange:  [-RFValue(22), RFValue(2)],
    });

    const backgroundColor = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [mainColor + '88', secondColor + '88'],
    });

    const handlePress = () => {
        setIsOn(!isOn);
        onToggle && onToggle(!isOn);
    };

    return (
        <TouchableOpacity activeOpacity={0.8} onPress={handlePress}>
            <Animated.View style={[styles.switch, { backgroundColor }]}>
                <Animated.View style={[styles.circle, { transform: [{ translateX }] }]} />
            </Animated.View>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    switch: {
        width: RFValue(32),
        height: RFValue(10),
        borderRadius: 20,
        justifyContent: "center",
        paddingHorizontal: 2,
        marginVertical: 5,
    },
    circle: {
        width: 17,
        height: 17,
        borderRadius: 10,
        backgroundColor: "#fff",
        elevation: 2,
    },
});

export default SwitchToggle;
